// extracted by mini-css-extract-plugin
module.exports = {"events":"Events_events__jyoZu","btn":"Events_btn__2ZqLS","loader":"Events_loader__mtzQl"};